import { mapActions, mapState } from 'pinia';
import { notifyInfo } from 'src/composables/interactions';
import { serviceWorker } from 'src/store/serviceWorker';

export default {
  data() {
    return {
      // refresh variables
      refreshing: false,
    };
  },

  computed: mapState(serviceWorker, ['registration']),

  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true });

    if ('serviceWorker' in navigator && typeof navigator.serviceWorker !== 'undefined') {
      // refresh page when a new service worker is activated
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Prevent multiple refreshes
        if (this.refreshing) {
          return;
        }

        this.refreshing = true;
        // Here the actual reload of the page occurs
        window.location.reload();
      });
    }
  },

  methods: {
    ...mapActions(serviceWorker, ['updateRegistration', 'refreshApp']),

    // Store the SW registration so we can send it a message
    updateAvailable(event) {
      if (event.detail.waiting.state !== 'installed') {
        return;
      }

      this.updateRegistration(event.detail);

      const isInOfflineMode = JSON.parse(localStorage.getItem('offlineModeStatus'));

      const isFirstLoad = !navigator.serviceWorker.controller;
      if (this.$route.path.includes('/run/') || isInOfflineMode || isFirstLoad) {
        return;
      }

      notifyInfo(`${this.$t('versionUpdate.title')} ${this.$t('versionUpdate.text')}`, {
        icon: 'cached',
        classes: 'notify-update-version',
        progress: false,
        timeout: 0,
        actions: [{
          label: this.$t('common.buttonLater'),
        }, {
          label: this.$t('versionUpdate.ok'),
          handler: this.refreshApp,
        }],
      });
    },
  },
};
